import Spacing from '@/components/container/Spacing';
import Container from '../../../components/container/Container';
import { CustomText, TextBodyMedium, TextHeadlineLarge } from '../../../components/text/Texts';
import { useAuthenticationStore } from '@/store';
import { AuthenticationState } from '@/types';

const WelcomeHeader = () => {
	const { user } = useAuthenticationStore((state: AuthenticationState) => state);

	return (
		<Container>
			<CustomText
				className="font-poppins text-[20px] leading-[20px] text-primary70"
				text={`Welcome, ${user.firstName} ${user.lastName}`}
			/>
			<Spacing height="h-[8px]" />
			<TextHeadlineLarge
				text="Complete your account setup"
				className="text-primary"
			/>
			<Spacing height="h-[20px]" />

			{/* <RoundedFilledButton
				id="send-invite"
				label="Test1"
				className="w-full text-lg font-poppins"
				onClick={
					() => NiceModal.show(TestDialogModal1, { id: 'test2', name: 'Bood' })
				}
			/> */}
			<TextBodyMedium
				text="Welcome to your Xpress for Business dashboard! Here, you can effortlessly control access to your benefits, track account activity, handle billing and payments, and much more. Just a few quick steps stand between you and your team diving into the world of Xpress for Business!"
				className="text-neutral17"
			/>
		</Container>
	);
};

export default WelcomeHeader;
